import { ChangeDetectionStrategy, Component, computed, input, InputSignal, Signal } from '@angular/core';

import { CmsContent, CmsTaxonomy } from '@fcom/core-api';

@Component({
  selector: 'fin-article-tag',
  templateUrl: './article-tag.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ArticleTagComponent {
  content: InputSignal<CmsContent> = input.required<CmsContent>();
  templateTags: InputSignal<CmsTaxonomy[]> = input.required<CmsTaxonomy[]>();

  contentTags: Signal<CmsTaxonomy[]> = computed((): CmsTaxonomy[] => this.content().subjectTaxonomyTags ?? []);
  renderTag: Signal<boolean> = computed((): boolean =>
    this.templateTags().some((tag): boolean => this.contentTags().includes(tag))
  );
}
